import {
    GET_LIST_CLASS_CERTIFICATE, IS_LOADING_GET_LIST_CLASS_CERTIFICATE, DELETE_CLASS_CERTIFICATE, GET_CLASS_CERTIFICATE, ADD_CLASS_CERTIFICATE, EDIT_CLASS_CERTIFICATE,
    IS_LOADING_LIST_STATE_CONCEPT_CERTIFICATE, GET_LIST_STATE_CONCEPT_CERTIFICATE, IS_LOADING_GET_LIST_TYPE_CERTIFICATE, ADD_TYPE_CERTIFICATE, EDIT_TYPE_CERTIFICATE,
    GET_LIST_TYPES_CERTIFICATES, DELETE_TYPE_CERTIFICATE, CHANGE_STATE_CONCEPT_CERTIFICATE, IS_LOADING_LIMITS_LIST, ADD_LIMIT, EDIT_LIMIT, GET_LIST_LIMIT, DELETE_LIMIT,
    IS_LOADING_GET_AUTH_REQUEST, GET_AUTH_REQUEST, IS_LOADING_GET_AUTH_REQUEST_BY_ID, GET_AUTH_REQUEST_BY_ID, CHANGE_AUTH_STATE, IS_LOADING_CHANGE_STATE,
    IS_LOADING_GET_PENDING_AUTH_FRANCHISE, GET_PENDING_AUTH_FRANCHISE, AUTH_FRANCHISE_BY_ID, IS_LOADING_AUTH_FRANCHISE_BY_ID,
    IS_LOADING_CHANGE_STATE_FRAN, CHANGE_FRANCHISE_STATE, LOADING_REPRESENTATIVE_REQUEST, REPRESENTATIVE_REQUEST_SUCCESS, LOADING_REPRESENTATIVE_REQUEST_BY_ID,
    AUTH_REPRESENTATIVE_BY_ID_SUCCESS, LOADING_CHANGE_STATE_REPRE, CHANGE_REPRESENTATIVE_STATE
} from '../actions/types'

const initialState = {
    listClassCertifications: [],
    isLoadingListClassCertificates: false,
    classCertificationInfo: {},
    isLoadingAuthRequest: false,
    
    isLoadingListTypesCertificates: false,
    listTypesCertifications: [],
    listLimit: [],
    isLoadingLimitList: false,


    isLoadingAuthRequestbyId: false,
    isLoadingRepresentativeRequest: false,
    isLoadingGetAuthFranchise: false,

    listFranchiseRequest: [],
    listRepresentativeRequest: [],
    listStateConceptCertificate: [],
    
    authRequest: {},
    franchiseRequest:{},
    representativeRequest:{},
    
    isLoadingChangeAuthState: false,
    
    
}

export default function (state = initialState, action) {
    switch (action.type) {

        case IS_LOADING_GET_LIST_TYPE_CERTIFICATE:
            return { ...state, isLoadingListTypesCertificates: true }
        case ADD_TYPE_CERTIFICATE:
            var addTypeCertificate = state.listTypesCertifications
            addTypeCertificate.push(action.payload)
            return { ...state, listTypesCertifications: addTypeCertificate, isLoadingListTypesCertificates: false }
        case EDIT_TYPE_CERTIFICATE:
            console.log()
            var editTypeCertificate = state.listTypesCertifications
            editTypeCertificate[action.payload.index] = action.payload.data
            return { ...state, listTypesCertifications: editTypeCertificate, isLoadingListTypesCertificates: false }
        case GET_LIST_TYPES_CERTIFICATES:
            console.log()
            return { ...state, listTypesCertifications: action.payload, isLoadingListTypesCertificates: false }
        case DELETE_TYPE_CERTIFICATE:
            var deleteTypeCertificate = state.listTypesCertifications
            deleteTypeCertificate.splice(action.payload, 1)
            return { ...state, isLoadingListTypesCertificates: false, listTypesCertifications: deleteTypeCertificate }

        case IS_LOADING_GET_LIST_CLASS_CERTIFICATE:
            return { ...state, isLoadingListClassCertificates: true }
        case ADD_CLASS_CERTIFICATE:
            var addClassCertificate = state.listClassCertifications
            addClassCertificate.push(action.payload)
            return { ...state, listClassCertifications: addClassCertificate, isLoadingListClassCertificates: false }
        case EDIT_CLASS_CERTIFICATE:
            console.log()
            var editClassCertificate = state.listClassCertifications
            editClassCertificate[action.payload.index] = action.payload.data
            console.log()
            return { ...state, listClassCertifications: editClassCertificate, isLoadingListClassCertificates: false }
        case GET_LIST_CLASS_CERTIFICATE:
            console.log()
            return { ...state, listClassCertifications: action.payload, isLoadingListClassCertificates: false }
        case DELETE_CLASS_CERTIFICATE:
            var deleteClassCertificate = state.listClassCertifications
            deleteClassCertificate.splice(action.payload, 1)
            return { ...state, isLoadingListClassCertificates: false, listClassCertifications: deleteClassCertificate }


        case IS_LOADING_LIMITS_LIST:
            return { ...state, isLoadingLimitList: true }
        case ADD_LIMIT:
            var addLimit = state.listLimit
            addLimit.push(action.payload)
            return { ...state, listLimit: addLimit, isLoadingLimitList: false }
        case EDIT_LIMIT:
            console.log()
            var editLimit = state.listLimit
            editLimit[action.payload.index] = action.payload.data
            return { ...state, listLimit: editLimit, isLoadingLimitList: false }
        case GET_LIST_LIMIT:
            console.log()
            return { ...state, listLimit: action.payload, isLoadingLimitList: false }
        case DELETE_LIMIT:
            var deleteLimit = state.listLimit
            deleteLimit.splice(action.payload, 1)
            return { ...state, isLoadingLimitList: false, listLimit: deleteLimit }



        case GET_CLASS_CERTIFICATE:
            return { ...state, classCertificationInfo: action.payload }
            


        //    
        case IS_LOADING_GET_AUTH_REQUEST:
            return { ...state, isLoadingAuthRequest: true }
        case GET_AUTH_REQUEST:
            return { ...state, isLoadingAuthRequest: false, listStateConceptCertificate: action.payload }
        case CHANGE_STATE_CONCEPT_CERTIFICATE:
            var changeCertificate = state.listStateConceptCertificate
            changeCertificate.splice(action.payload, 1)
            return { ...state, isLoadingListStateConceptCertificates: false, listStateConceptCertificate: changeCertificate }
        case IS_LOADING_GET_AUTH_REQUEST_BY_ID:
            return { ...state, isLoadingAuthRequestbyId: true }
        case GET_AUTH_REQUEST_BY_ID:
            return { ...state, isLoadingAuthRequestbyId: false, authRequest: action.payload }
        case IS_LOADING_CHANGE_STATE:
            return { ...state, isLoadingChangeAuthState: true }
        case CHANGE_AUTH_STATE:
            return { ...state, isLoadingChangeAuthState: false, authRequest: action.payload }

        case IS_LOADING_GET_PENDING_AUTH_FRANCHISE:
            return { ...state, isLoadingGetAuthFranchise: true }
        case GET_PENDING_AUTH_FRANCHISE:
            return { ...state, isLoadingGetAuthFranchise: false, listFranchiseRequest: action.payload }
        case IS_LOADING_AUTH_FRANCHISE_BY_ID:
            return { ...state, isLoadingGetAuthFranchise: true }
        case AUTH_FRANCHISE_BY_ID:
            return { ...state, isLoadingGetAuthFranchise: false, franchiseRequest: action.payload }
        case IS_LOADING_CHANGE_STATE_FRAN:
            return { ...state, isLoadingChangeAuthState: true }
        case CHANGE_FRANCHISE_STATE:
            return { ...state, isLoadingChangeAuthState: false, franchiseRequest: action.payload }

        case LOADING_REPRESENTATIVE_REQUEST:
            return { ...state, isLoadingRepresentativeRequest: true }
        case REPRESENTATIVE_REQUEST_SUCCESS:
            return { ...state, isLoadingRepresentativeRequest: false, listRepresentativeRequest: action.payload }
        case LOADING_REPRESENTATIVE_REQUEST_BY_ID:
            return { ...state, isLoadingRepresentativeRequest: true }
        case AUTH_REPRESENTATIVE_BY_ID_SUCCESS:
            return { ...state, isLoadingRepresentativeRequest: false, representativeRequest: action.payload }
        case LOADING_CHANGE_STATE_REPRE:
            return { ...state, isLoadingChangeAuthState: true }
        case CHANGE_REPRESENTATIVE_STATE:
            return { ...state, isLoadingChangeAuthState: false, representativeRequest: action.payload }
        default:
            return state

    }
}